import Splide from '@splidejs/splide';



export const HeroSlider = () => {

    const slider = document.getElementById('hero-slider')
    const interval = 7000 

    new Splide(slider, {
        arrows: false,
        type: 'loop',
        //speed: 700,
        interval: interval,
        resetProgress: false,
        autoplay: true,
        perMove: 1,
        easing: 'linear',
        pauseOnHover: false,
        mediaQuery: 'min',
        breakpoints: {
            768: {
                destroy: true,
                label: 'My Gallery', // Used after destruction
            }
        },
        classes: {
            page: 'splide__pagination-page',
        },
        i18n: {
            prev: 'Vorherige Folie',
            next: 'Nächste Folie',
            first: 'Zur ersten Folie gehen',
            last: 'Zur letzten Folie gehen',
            slideX: 'Zur Folie %s gehen',
            pageX: 'Zur Seite %s gehen',
            play: 'Autoplay starten',
            pause: 'Autoplay pausieren',
            carousel: 'Karussell',
            select: 'Eine Folie zum Anzeigen auswählen',
            slide: 'Folie',
            slideLabel: '%s von %s'
        }
    }).mount()


    const sliderSlide = [...slider.querySelectorAll('.splide__slide')]
    const sliderNavLink = [...slider.querySelectorAll('.hero-slider__nav-link')]
    const progressBar = slider.querySelector('.hero-slider__progress-bar')
    const animation = progressBar.getAnimations()
    const activeClass = 'is-active'
    let sliderInterval = null
    let sliderIndex = -1

    slider.style.setProperty('--hero-slider-interval', interval + 'ms')

    sliderNavLink.map((e, index) => e.addEventListener('click', () => setActiveSlide(index, true)))

    function updateSlide() {
        sliderIndex = sliderIndex + 1
        setActiveSlide(sliderIndex)
    }

    updateSlide()
    function reInitInterval() {
        clearInterval(sliderInterval)
        sliderInterval = setInterval(() => updateSlide(), interval)
    }
    reInitInterval()

    function setActiveSlide(index, reset = false) {
        let safeIndex = index % sliderSlide.length

        // rewind
        if (index > sliderSlide.length) {
            sliderIndex = 1
            index = safeIndex
            slider.style.setProperty('--hero-slider-index-duration', 0)
            slider.style.setProperty('--hero-slider-index', 0)
        }

        setTimeout(() => {
            slider.style.removeProperty('--hero-slider-index-duration')
            slider.style.setProperty('--hero-slider-index', index)
        }, 100);

        // update slider
        sliderSlide.map(e => e.classList.remove(activeClass))
        sliderSlide[safeIndex].classList.add(activeClass)

        // update nav
        sliderNavLink.map(e => e.classList.remove(activeClass))
        sliderNavLink[index].classList.add(activeClass)

        // restart animation
        if (animation.length) {
            animation[0].cancel()
            animation[0].play()
        }
      

        if (reset) {
            reInitInterval()
        }

    }

}
